import React from "react";
import "./Themes.scss";
import AnimatedLogo from "../elements/AnimatedLogo";

const ThemeDefault = ({ children }: { children?: React.ReactNode }) => {
    return (
        <div className="is-theme-default">
            {children}
            <div className="nav-body-vectors">
                <AnimatedLogo
                    alt="QR Cook"
                    width={125}
                    height={125}
                    shouldPlay={true}
                    border={"none"}
                    borderRadius={"0%"}
                    hideBackground={true}
                />
            </div>
        </div>
    );
};

export default ThemeDefault;

